<template>
  <pre><code><slot>なんもないよ！</slot></code></pre>
</template>

<script>
// import highlight from 'highlight.js'
export default {
  mounted () {
    // highlight.highlightBlock(this.$el.childNodes[0])
  }
}
</script>

<style lang="scss">
/* @import "../../../node_modules/highlight.js/styles/atom-one-dark.css" */
</style>



// WEBPACK FOOTER //
// HighLight.vue?352b2392